import { Dispatch, SetStateAction } from "react";
import { emailValid, nameValid } from "@power-rent/data-validation";
import { InitialContactObject } from "pages/contact";

type ValidateCheckoutFormProps = {
  formValues: InitialContactObject;
  setInputErrors: Dispatch<SetStateAction<InitialContactObject>>;
};

export const validateContactForm = ({ formValues, setInputErrors }: ValidateCheckoutFormProps) => {
  const errors = {} as InitialContactObject;
  if (!formValues.name) {
    errors.name = "Name must be filled up";
  }
  if (!emailValid(formValues.email)) {
    errors.email = "Invalid email";
  }
  if (!formValues.text) {
    errors.text = "Text must be filled up";
  }
  const errorsWithValuesArray = Object.entries(errors).filter(([, value]) => value);
  if (errorsWithValuesArray[0]) {
    const firstErrorInput = document.getElementsByName(errorsWithValuesArray[0][0]);
    window.scrollTo({
      top: firstErrorInput[0].offsetTop - 150,
      behavior: "smooth",
    });
  }

  setInputErrors(errors);
  return errors;
};
